/**
     * Replaces placeholders in text with actual data values.
     * Supported variables: {studentName}, {parentName}, {amountDue}, {companyName}, etc.
     */
    export const replaceVariables = (text, data) => {
      if (!text) return '';
      
      let result = text;

      // formatting helpers
      const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0);
      };

      const replacements = {
        // Student/Parent Context
        '{studentName}': data.studentName || 'Student',
        '{parentName}': data.parentName || 'Parent',
        '{amountDue}': data.amountDue ? formatCurrency(data.amountDue) : '$0.00',
        '{totalSessions}': data.totalSessions || '0',
        '{unpaidSessions}': data.unpaidSessions || '0',
        
        // User/Account Context (For Welcome Emails)
        '{firstName}': data.firstName || 'User',
        '{lastName}': data.lastName || '',
        '{name}': data.name || `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'User',
        '{email}': data.email || '',
        '{username}': data.username || data.email || '',
        '{password}': data.password || '********',
        '{role}': data.role || 'User',
        
        // System Context
        '{companyName}': data.companyName || 'ExpertGuru',
      };

      Object.keys(replacements).forEach(key => {
        // Replace all occurrences (case-insensitive)
        const regex = new RegExp(key, 'gi');
        result = result.replace(regex, replacements[key]);
      });

      return result;
    };

    export const AVAILABLE_VARIABLES = [
      { label: 'Student Name', value: '{studentName}' },
      { label: 'Parent Name', value: '{parentName}' },
      { label: 'Amount Due', value: '{amountDue}' },
      { label: 'Company Name', value: '{companyName}' },
      { label: 'Total Sessions', value: '{totalSessions}' },
      { label: 'Unpaid Sessions', value: '{unpaidSessions}' },
      // New User Variables
      { label: 'First Name', value: '{firstName}' },
      { label: 'Last Name', value: '{lastName}' },
      { label: 'Username', value: '{username}' },
      { label: 'Password', value: '{password}' },
      { label: 'Email', value: '{email}' },
      { label: 'User Role', value: '{role}' },
    ];